import { Routes } from '@angular/router';
import { LieferantenRepository } from './repositories/lieferanten.repository';
import { LieferantenService } from './services/lieferanten.service';
import { LieferantenFibuRepository } from './repositories/lieferanten-fibu.repository';
import { LieferantenFibuService } from './services/lieferanten-fibu.service';
import { LieferantenProduktgruppeRepository } from './repositories/lieferanten-produktgruppe.repository';
import { LieferantenProduktgruppeService } from './services/lieferanten-produktgruppe.service';
import { LieferantenRabattRepository } from './repositories/lieferanten-rabatt.repository';
import { LieferantenRabattService } from './services/lieferanten-rabatt.service';
import { LieferantenWwsRepository } from './repositories/lieferanten-wws.repository';
import { LieferantenWwsService } from './services/lieferanten-wws.service';
import { LieferantenDokumenteRepository } from './repositories/lieferanten-dokumente.repository';
import { LieferantenDokumenteService } from './services/lieferanten-dokumente.service';
import { LieferantenKontakteRepository } from './repositories/lieferanten-kontakte.repository';
import { LieferantenKontakteService } from './services/lieferanten-kontakte.service';
import { AuthorizationGuard } from '@softline/auth';

export const lieferantenstammRoutes: Routes = [
  {
    path: 'lieferantenstamm',
    loadComponent: () =>
      import('./pages/lieferantensuche/lieferantensuche.component').then(
        (o) => o.LieferantensucheComponent
      ),
  },
  {
    path: 'lieferantenstamm/:id',
    loadComponent: () =>
      import('./pages/lieferanten-detail/lieferanten-detail.page').then(
        (o) => o.LieferantenDetailPage
      ),
    providers: [
      LieferantenRepository,
      LieferantenService,
      LieferantenFibuRepository,
      LieferantenFibuService,
      LieferantenProduktgruppeRepository,
      LieferantenProduktgruppeService,
      LieferantenRabattRepository,
      LieferantenRabattService,
      LieferantenWwsRepository,
      LieferantenWwsService,
      LieferantenDokumenteRepository,
      LieferantenDokumenteService,
      LieferantenKontakteRepository,
      LieferantenKontakteService,
    ],
    canActivate: [AuthorizationGuard],
  },
];
